export default __webpack_public_path__ + "static/media/rnr-sports-table-27-cn.0962343f.webp";